export default __webpack_public_path__ + "ab87f23e6bba4860807fca167f89d269.ogg";